import React from 'react';
import RotatingAdPicker from './RotatingAdPicker';

export default function AdRotationEditor({ rotationForm, setRotationForm, rotationEditing, adRotations, availableFullScreenAds, playableFullScreenAds, rotationSaving, onCancel, onSave }) {
  return (
    <fieldset disabled={rotationSaving} className="grid min-w-0 w-full gap-4">
      <div className="grid md:grid-cols-[minmax(0,1fr),140px] gap-3">
        <label className="grid gap-1 text-xs text-slate-300">
          <span>Name</span>
          <input
            className="rounded-xl bg-black/30 ring-1 ring-white/10 p-2 text-sm text-white"
            value={rotationForm.name}
            disabled={rotationForm.mode === 'all'}
            onChange={(e) => setRotationForm((prev) => ({ ...prev, name: e.target.value }))}
          />
        </label>
        <label className="grid gap-1 text-xs text-slate-300">
          <span>Duration (seconds per ad)</span>
          <input
            type="number"
            min="1"
            className="rounded-xl bg-black/30 ring-1 ring-white/10 p-2 text-sm text-white"
            value={rotationForm.duration_sec}
            onChange={(e) =>
              setRotationForm((prev) => ({
                ...prev,
                duration_sec: Math.max(1, Number(e.target.value) || 60),
              }))
            }
          />
        </label>
      </div>

      <label className="flex items-center gap-2 text-sm text-slate-200">
        <input type="checkbox" checked={rotationForm.showInEpg === true}
          onChange={(event) => setRotationForm((prev) => ({ ...prev, showInEpg: event.target.checked }))} />
        Show in EPG
      </label>

      <div className="grid min-w-0 gap-2">
        <div className="text-xs font-semibold uppercase tracking-[0.16em] text-slate-400">Mode</div>
        <div className="flex flex-wrap gap-2">
          <button
            type="button"
            onClick={() =>
              setRotationForm((prev) => ({
                ...prev,
                mode: 'custom',
                name: prev.name === 'All Ads' ? `Ad Rotation ${adRotations.length + 1}` : prev.name,
              }))
            }
            disabled={rotationEditing?.mode === 'all'}
            className={`rounded-xl px-3 py-2 text-xs ring-1 ring-white/10 ${
              rotationForm.mode === 'custom' ? 'bg-white/15 text-white' : 'bg-white/5 text-slate-300 hover:bg-white/10'
            } disabled:cursor-not-allowed disabled:opacity-50`}
          >
            Selected Ads
          </button>
          <button
            type="button"
            onClick={() =>
              setRotationForm((prev) => ({
                ...prev,
                mode: 'all',
                name: 'All Ads',
              }))
            }
            disabled={rotationEditing?.mode !== 'all'}
            className={`rounded-xl px-3 py-2 text-xs ring-1 ring-white/10 ${
              rotationForm.mode === 'all' ? 'bg-white/15 text-white' : 'bg-white/5 text-slate-300 hover:bg-white/10'
            } disabled:cursor-not-allowed disabled:opacity-50`}
          >
            Everything
          </button>
        </div>
        <div className="text-xs text-slate-500">
          Everything automatically includes enabled campaigns, social ads, default ads, and menu items with artwork.
        </div>
      </div>

      <div className="grid min-w-0 gap-2">
        <div className="flex flex-wrap items-center justify-between gap-2">
          <div>
            <div className="text-xs font-semibold uppercase tracking-[0.16em] text-slate-400">
              Full-screen ads
            </div>
            <div className="text-xs text-slate-500">
              {rotationForm.mode === 'all'
                ? `${playableFullScreenAds.length} ads will be included automatically`
                : `${rotationForm.overlayIds.length} selected`}
            </div>
          </div>
        </div>
        <RotatingAdPicker
          idPrefix={rotationEditing ? 'saved-rotation' : 'new-rotation'}
          ads={availableFullScreenAds}
          selectedIds={rotationForm.overlayIds}
          automatic={rotationForm.mode === 'all'}
          onChange={(overlayIds) => setRotationForm((prev) => ({ ...prev, overlayIds }))}
        />
      </div>

      <div className="flex flex-wrap justify-end gap-2">
        <button
          type="button"
          className="rounded-xl bg-white/10 px-3 py-2 text-sm text-white hover:bg-white/20"
          onClick={onCancel}
        >
          {rotationEditing ? 'Reset' : 'Cancel'}
        </button>
        <button
          type="button"
          className="rounded-xl bg-emerald-600/90 px-3 py-2 text-sm font-semibold text-white hover:bg-emerald-600 disabled:opacity-60"
          disabled={rotationSaving}
          onClick={onSave}
        >
          {rotationSaving ? 'Saving...' : 'Save Rotation'}
        </button>
      </div>
    </fieldset>
  );
}
